var cleanHtml = function cleanHtml(text) {
  return typeof text === 'string' ? text.replace(/<br\s?\/?>/gi, ' ').replace(/(<.*?>|\s(?=\s))/g, '').trim() : text;
};
export default cleanHtml;